import { useState } from 'react';

function TablesList({ tables, onActivate, onRemove, loading = false }) {
    const [search, setSearch] = useState('');

    const filteredTables = tables.filter((table) =>
        (table.name || table.tableName || '').toLowerCase().includes(search.toLowerCase())
    );

    const handleRemoveTable = (id) => {
        if (onRemove) {
            onRemove(id);
        }
    };

    const tableElements = filteredTables.map((table) => (
        <div key={table.id} className="h-18 p-4 flex items-center justify-between border border-gray-200 rounded-lg shadow-sm bg-white hover:bg-gray-50 transition">
            <div>
                <h3 className="text-lg font-medium text-gray-900">{table.name || table.tableName}</h3>
                <div className="mt-1 text-sm text-gray-500">
                    {table.is_active ? 'Active' : 'Inactive'}
                </div>
            </div>
            <div className="flex gap-3">
                <button
                    className="bg-red-500 text-white p-2 rounded-lg hover:bg-red-600 transition disabled:opacity-50"
                    onClick={() => handleRemoveTable(table.id)}
                    disabled={loading}
                >
                    Remove
                </button>
            </div>
        </div>
    ));

    return (
        <div className="mt-6 border-t border-gray-300">
            <h1 className="text-xl my-3">All Tables</h1>
            <input
                type="text"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder="Search Table"
                className="w-full rounded-2xl border border-gray-300 bg-white px-4 py-2 text-sm text-gray-700 outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-100 mb-4"
            />
            <div className="grid gap-2 overflow-y-auto max-h-[320px]">
                {tableElements}
            </div>
        </div>
    );
}

export default TablesList;